import req from '../req'
// 开屏广告设置

// 获取开屏广告设置
export function getOpenScreenAd (params) {
  return req.get('/setting/open-screen-ad/info', params)
}

// 保存开屏广告设置
export function saveOpenScreenAd (params) {
  return req.post('/setting/open-screen-ad/save', params)
}
